/**
 * The site origin for canonical URLs. On the client this is the real location;
 * the server passes PUBLIC_BASE_URL into the loaders instead, so this is only
 * ever called in the browser.
 */
export function origin(): string {
  return typeof location !== "undefined" ? location.origin : "";
}
